<template>
    <div class="intelligence-chart intelligence-chart--funnel">
        <h3 class="intelligence-chart__title">{{ $t('pages.intelligence.charts.referral_funnel') }}</h3>
        <div v-if="hasData" class="intelligence-chart__body">
            <apexchart type="bar" height="280" :options="chartOptions" :series="series"></apexchart>
            <ul class="intelligence-chart__dropoffs">
                <li v-for="item in dropOffItems" :key="item.label">
                    {{ item.label }}: {{ item.text }}
                </li>
            </ul>
        </div>
        <p v-else class="intelligence-chart__empty">{{ $t('pages.intelligence.overview.empty') }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            funnel: {
                type: Array,
                default: () => [],
            },
        },

        computed: {
            hasData() {
                return this.funnel.some((stage) => stage.count > 0)
            },

            stageLabels() {
                return this.funnel.map((stage) => this.$t(`pages.intelligence.funnel.${stage.stage}`))
            },

            series() {
                return [
                    {
                        name: 'Referrals',
                        data: this.funnel.map((stage) => stage.count),
                    },
                ]
            },

            chartOptions() {
                return {
                    chart: {
                        type: 'bar',
                        toolbar: { show: false },
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            borderRadius: 4,
                            barHeight: '55%',
                        },
                    },
                    colors: ['#1e3a8a'],
                    dataLabels: {
                        enabled: true,
                    },
                    xaxis: {
                        categories: this.stageLabels,
                    },
                    grid: {
                        borderColor: '#e5e7eb',
                    },
                }
            },

            dropOffItems() {
                const items = []

                for (let i = 1; i < this.funnel.length; i++) {
                    const prev = this.funnel[i - 1]
                    const curr = this.funnel[i]
                    if (curr.dropOffPercent !== null && curr.dropOffPercent !== undefined) {
                        items.push({
                            label: `${this.$t(`pages.intelligence.funnel.${prev.stage}`)} → ${this.$t(`pages.intelligence.funnel.${curr.stage}`)}`,
                            text: this.$t('pages.intelligence.charts.drop_off', { percent: curr.dropOffPercent }),
                        })
                    }
                }

                return items
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-chart {
        background: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        padding: 20px;
    }

    .intelligence-chart__title {
        margin: 0 0 16px;
        font-size: 16px;
        font-weight: 600;
        color: #111827;
    }

    .intelligence-chart__dropoffs {
        margin: 12px 0 0;
        padding-left: 18px;
        color: #6b7280;
        font-size: 13px;
    }

    .intelligence-chart__empty {
        margin: 0;
        color: #6b7280;
        font-size: 14px;
    }
</style>
